import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { IconStyleRow, IconSearchBar, IconSearchBarContainer } from './styles';
import { createSearchFunction } from '../../utils';
var filterIcons = createSearchFunction(['iconName']);
export var IconSearch = function (_a) {
    var iconList = _a.iconList, onSearch = _a.onSearch;
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var updateSearch = function (e) {
        var value = e.target.value;
        setSearch(value);
    };
    useEffect(function () {
        onSearch(filterIcons(search, iconList));
    }, [search, iconList, onSearch]);
    return (_jsx(IconStyleRow, { children: _jsx(IconSearchBarContainer, { children: _jsx(IconSearchBar, { value: search, onChange: updateSearch, placeholder: "ex: arrow right" }) }) }));
};
